import {faTags} from '@fortawesome/free-solid-svg-icons/faTags';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {dateFormatFR} from '../../../utils';
import DataTable from '../../../common/components/Datatable/Datatable';
import Screen from '../../../common/components/layout/Screen';
import Span from '../../../common/components/layout/Span';
import Metadata from '../../../common/components/Metadata';
import {FILTER_EXPRESSION_OPERATOR, FILTER_OPERATOR} from '../../../common/constants';
import {GRAPHQL_QUERY_TAGS} from '../../../common/queries/tag';
import AddTag from './AddTag';
import TagRowAction from './TagRowAction';


const columns = t => [
  {
    Header: '#',
    accessor: 'id',
    sortable: true,
  },
  {
    Header: t('name'),
    accessor: 'name',
    sortable: true,
  },
  {
    accessor: 'totalReceipts',
    Header: t('ticketsNb'),
  },
  {
    Header: t('creation'),
    Cell: ({cell}) => dateFormatFR({date: cell.value}),
    accessor: 'createdAt',
  },
  {
    Header: t('action'),
    Cell: ({cell}) => <TagRowAction tag={cell.value}/>,
    accessor: row => row,
  },
];

const TagView = ({t}) => {
  const [advancedFilters, setAdvancedFilters] = React.useState(null);
  const onSearch = search => setAdvancedFilters({
    operator: FILTER_EXPRESSION_OPERATOR.Or,
    filters: [{
      field: 'id',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    }, {
      field: 'name',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    }],
  });

  return (
    <Screen
      header={<Metadata title={t('title')} meta={t('meta')}/>}
      leftTitle={
        <>
          <FontAwesomeIcon icon={faTags} color={'rgb(201,0,95)'}/>
          <Span className="route-name">{t('tags')}</Span>
        </>
      }
      rightTitle={<AddTag/>}>
      <DataTable
        columns={columns(t)}
        keyResult="tags"
        query={GRAPHQL_QUERY_TAGS}
        defaultSort={{field: 'name'}}
        advancedFilters={advancedFilters}
        onSearch={onSearch}/>
    </Screen>
  );
};

TagView.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('tag')(TagView);
